import Geocode from 'types/Geocode';
import Prediction from 'lib/location/Locations/Prediction';

export default async function geocodeAndThen(
  prediction: Prediction,
  onGeocode: (result: Geocode) => void
): Promise<void> {
  const geocode = await prediction.toGeocode();
  if (geocode) {
    onGeocode(geocode);
  }
}
